(function () {
    "use strict";
    realmCommerceApp.factory("itemsService", ItemsService);

    /*@ngInject*/
    function ItemsService() {
        var service = {
            addItem: addItem,
            getItemsByIdentifier: getItemsByIdentifier,
            removeItem: removeItem,
            byProperty: byProperty,
            items: []
        }
        return service;

        function getItemsByIdentifier(identifier) {
            var itemList = service.items.filter(function (object) {
                return object.identifier == identifier;
            });
            return itemList;
        }

        function addItem(identifier, item) {
            service.items.push(angular.merge(item, {
                identifier: identifier
            }));
        }

        function removeItem(identifier, cartItemId) {
            var item = service.getItemsByIdentifier(identifier).filter(function (object) {
                return object["cartItemId"] == cartItemId;
            });
            var idx = service.items.indexOf(item[0]);
            service.items.splice(idx, 1);
            return service.items;
        }

        function byProperty(identifier, property, value) {
            var item = service.getItemsByIdentifier(identifier).filter(function (object) {
                return object[property] == value;
            });
            return item;
        }

    }
})();


// WEBPACK FOOTER //
// ./static/js/app/services/items.service.js